import type { CatalogError } from './types';

export const catalogStaleTime = {
  categories: 5 * 60_000,
  products: 3 * 60_000,
  product: 5 * 60_000,
  featured: 3 * 60_000,
} as const;

export function catalogRetry(failureCount: number, error: Error) {
  const catalogError = error as CatalogError;
  if (
    catalogError.status === 400 ||
    catalogError.status === 404 ||
    catalogError.code === 'invalid-filter' ||
    catalogError.code === 'invalid-response'
  )
    return false;
  return failureCount < 2;
}

export function catalogRetryDelay(attempt: number) {
  return Math.min(500 * 2 ** attempt, 3_000);
}
